/* ============================================================
 * RoyalChicByPriti — Conversion mechanics layer
 * Injects: announcement marquee (seamless), PDP trust block,
 *          WhatsApp inquiry button, sticky mobile cart,
 *          recently viewed, cart drawer free-shipping badge,
 *          floating WhatsApp FAB, newsletter popup.
 * ============================================================ */
(function () {
  'use strict';

  var WHATSAPP_NUMBER = '919810992373';
  var RECENTLY_VIEWED_KEY = 'rc_recently_viewed_v1';
  var RECENTLY_VIEWED_MAX = 8;
  var MARQUEE_COPIES = 4;
  var NEWSLETTER_KEY = 'rc_newsletter_status_v1';
  var NEWSLETTER_EMAILS_KEY = 'rc_newsletter_emails_v1';
  var NEWSLETTER_DELAY_MS = 18000;
  var NEWSLETTER_REPROMPT_DAYS = 30;

  function isProductPage() {
    return document.body.classList.contains('template-product') ||
           document.querySelector('main .product') !== null ||
           window.location.pathname.indexOf('/products/') === 0;
  }

  function readProductMeta() {
    var ogTitle = document.querySelector('meta[property="og:title"]');
    var ogUrl = document.querySelector('meta[property="og:url"]') || document.querySelector('link[rel="canonical"]');
    var ogImage = document.querySelector('meta[property="og:image"]');
    var priceEl = document.querySelector('.price-item--regular, .price-item--sale, .price__regular .price-item');
    return {
      title: ogTitle ? ogTitle.getAttribute('content') : document.title,
      url: ogUrl ? ogUrl.getAttribute('content') || ogUrl.getAttribute('href') : window.location.href,
      image: ogImage ? ogImage.getAttribute('content') : null,
      price: priceEl ? priceEl.textContent.trim() : ''
    };
  }

  // ---------- Seamless announcement marquee ----------
  function setupAnnouncementMarquee() {
    var msg = document.querySelector('.announcement-bar__message') ||
              document.querySelector('.announcement-bar__announcement');
    if (!msg) return;
    if (msg.dataset.rcMarqueeReady === '1') return;

    var text = '';
    var nodes = msg.childNodes;
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      if (node.nodeType === 3) {
        text += node.textContent;
      } else if (node.nodeType === 1) {
        var tag = node.tagName ? node.tagName.toLowerCase() : '';
        var cls = node.className && typeof node.className === 'string' ? node.className : '';
        if (tag !== 'svg' && cls.indexOf('svg-wrapper') === -1 && cls.indexOf('icon-wrap') === -1) {
          text += node.textContent;
        }
      }
    }
    text = text.trim();
    if (!text) return;

    msg.innerHTML = '';
    msg.classList.add('rc-marquee-host');

    var track = document.createElement('span');
    track.className = 'rc-marquee-track';
    for (var j = 0; j < MARQUEE_COPIES; j++) {
      var item = document.createElement('span');
      item.className = 'rc-marquee-item';
      item.textContent = text;
      track.appendChild(item);
    }
    msg.appendChild(track);
    msg.dataset.rcMarqueeReady = '1';
  }

  // ---------- PDP Trust Block ----------
  function buildPdpTrustBlock(product) {
    var wrapper = document.createElement('div');
    wrapper.className = 'rc-pdp-trust';
    wrapper.innerHTML = [
      '<ul class="rc-pdp-trust__list">',
      '  <li class="rc-pdp-trust__item">',
      '    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"/><path d="M15 18h5a1 1 0 0 0 1-1v-3.34a2 2 0 0 0-.59-1.41l-2.66-2.66A2 2 0 0 0 16.34 9H14"/><circle cx="7.5" cy="18.5" r="2.5"/><circle cx="17.5" cy="18.5" r="2.5"/></svg>',
      '    <div><strong>Free Pan-India Shipping</strong><span>Ships in 24 hrs &middot; 4-7 days delivery</span></div>',
      '  </li>',
      '  <li class="rc-pdp-trust__item">',
      '    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s-8-4.5-8-11.5A5.5 5.5 0 0 1 12 6a5.5 5.5 0 0 1 8 4.5C20 17.5 12 22 12 22z"/></svg>',
      '    <div><strong>Authentic from Chandni Chowk</strong><span>Direct from wholesale market</span></div>',
      '  </li>',
      '  <li class="rc-pdp-trust__item">',
      '    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>',
      '    <div><strong>International Delivery</strong><span>US, UK, UAE, SG, AU &middot; 10-21 days</span></div>',
      '  </li>',
      '  <li class="rc-pdp-trust__item">',
      '    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></svg>',
      '    <div><strong>WhatsApp Support</strong><span>+91 98109 92373 &middot; quick replies</span></div>',
      '  </li>',
      '</ul>',
      '<div class="rc-pdp-trust__actions">',
      '  <a class="rc-pdp-trust__link" href="/blogs/style-guide/how-to-measure-unstitched-suit-size-guide" target="_blank" rel="noopener">',
      '    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M21 6H3"/><path d="M21 12H3"/><path d="M21 18H3"/></svg>',
      '    Size guide — how to measure',
      '  </a>',
      '  <a class="rc-pdp-trust__link" href="/blogs/style-guide/care-of-unstitched-fabrics" target="_blank" rel="noopener">',
      '    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M9 12l2 2 4-4"/></svg>',
      '    Fabric care &amp; washing guide',
      '  </a>',
      '</div>',
      '<div class="rc-pdp-trust__care">',
      '  <span class="rc-pdp-trust__care-item" title="Gentle wash">',
      '    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12c0 5-3.5 8-9 8s-9-3-9-8 4-9 9-9 9 4 9 9z"/><path d="M8 14a3 3 0 0 0 6 0"/></svg>',
      '    Gentle Wash',
      '  </span>',
      '  <span class="rc-pdp-trust__care-item" title="Cool iron">',
      '    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M6 6h12l3 6v6H3v-6z"/><circle cx="9" cy="14" r=".7"/><circle cx="15" cy="14" r=".7"/></svg>',
      '    Cool Iron',
      '  </span>',
      '  <span class="rc-pdp-trust__care-item" title="Dry clean recommended">',
      '    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M8 12h8"/></svg>',
      '    Dry Clean OK',
      '  </span>',
      '  <span class="rc-pdp-trust__care-item" title="No bleach">',
      '    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M3 21l18-18"/><path d="M5 3l14 14"/></svg>',
      '    No Bleach',
      '  </span>',
      '</div>'
    ].join('');
    return wrapper;
  }

  function buildWhatsAppButton(product) {
    var message = encodeURIComponent('Hi RoyalChicByPriti! I am interested in: ' + product.title + '\n\nLink: ' + product.url + '\n\nCould you help me with details?');
    var url = 'https://wa.me/' + WHATSAPP_NUMBER + '?text=' + message;
    var btn = document.createElement('a');
    btn.className = 'rc-whatsapp-btn';
    btn.href = url;
    btn.target = '_blank';
    btn.rel = 'noopener';
    btn.setAttribute('aria-label', 'Inquire about this product on WhatsApp');
    btn.innerHTML = [
      '<svg width="22" height="22" viewBox="0 0 24 24" fill="#fff"><path d="M17.5 14.4c-.3-.1-1.8-.9-2-1s-.5-.1-.7.1-.8 1-1 1.2-.4.2-.7.1-1.3-.5-2.5-1.5c-.9-.8-1.5-1.8-1.7-2.1-.2-.3 0-.5.1-.6s.3-.3.4-.5c.1-.2.2-.3.2-.5s-.1-.4-.2-.5c-.1-.1-.7-1.7-1-2.3-.3-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.7.4-.3.3-1 1-1 2.4s1 2.8 1.2 3 2 3 4.8 4.2c.7.3 1.2.5 1.6.6.7.2 1.3.2 1.8.1.5-.1 1.7-.7 2-1.4.2-.7.2-1.3.2-1.4-.1-.1-.3-.2-.5-.3z"/><path d="M12 2C6.5 2 2 6.5 2 12c0 1.8.5 3.5 1.4 5L2 22l5.2-1.4c1.4.8 3 1.2 4.8 1.2 5.5 0 10-4.5 10-10S17.5 2 12 2zm0 18.2c-1.6 0-3.1-.4-4.4-1.2l-.3-.2-3.2.9.9-3.1-.2-.3c-.9-1.4-1.3-3-1.3-4.6 0-4.5 3.7-8.2 8.2-8.2s8.2 3.7 8.2 8.2-3.7 8.2-8.2 8.2z"/></svg>',
      '<span>Inquire about this product</span>'
    ].join('');
    return btn;
  }

  function buildStickyMobileBar(product) {
    var bar = document.createElement('div');
    bar.className = 'rc-sticky-cart';
    bar.innerHTML = [
      '<div class="rc-sticky-cart__info">',
      '  <span class="rc-sticky-cart__title">' + (product.title || '').replace(/[<>]/g, '') + '</span>',
      '  <span class="rc-sticky-cart__price">' + (product.price || '') + '</span>',
      '</div>',
      '<button type="button" class="rc-sticky-cart__btn">Add to cart</button>'
    ].join('');
    bar.querySelector('.rc-sticky-cart__btn').addEventListener('click', function () {
      var realBtn = document.querySelector('product-form button[type="submit"]') ||
                    document.querySelector('form[action*="/cart/add"] button[type="submit"]') ||
                    document.querySelector('button[name="add"]');
      if (realBtn) {
        realBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(function () { realBtn.click(); }, 400);
      }
    });
    return bar;
  }

  // ---------- Recently viewed ----------
  function getRecentlyViewed() {
    try { var raw = localStorage.getItem(RECENTLY_VIEWED_KEY); return raw ? JSON.parse(raw) : []; } catch (e) { return []; }
  }

  function saveRecentlyViewed(item) {
    try {
      var list = getRecentlyViewed();
      list = list.filter(function (p) { return p.url !== item.url; });
      list.unshift(item);
      list = list.slice(0, RECENTLY_VIEWED_MAX);
      localStorage.setItem(RECENTLY_VIEWED_KEY, JSON.stringify(list));
    } catch (e) {}
  }

  function renderRecentlyViewed() {
    var list = getRecentlyViewed();
    var currentUrl = window.location.pathname;
    list = list.filter(function (p) { return p.url.indexOf(currentUrl) === -1; });
    if (list.length < 2) return null;
    var section = document.createElement('section');
    section.className = 'rc-recently-viewed';
    var html = ['<div class="page-width"><h2 class="rc-recently-viewed__heading h3">Recently viewed</h2><div class="rc-recently-viewed__grid">'];
    list.slice(0, 6).forEach(function (p) {
      html.push(
        '<a class="rc-recently-viewed__card" href="' + p.url + '">' +
          (p.image ? '<img src="' + p.image + '" alt="' + (p.title || '').replace(/"/g, '') + '" loading="lazy">' : '') +
          '<span class="rc-recently-viewed__title">' + (p.title || '').replace(/[<>]/g, '') + '</span>' +
          (p.price ? '<span class="rc-recently-viewed__price">' + p.price + '</span>' : '') +
        '</a>'
      );
    });
    html.push('</div></div>');
    section.innerHTML = html.join('');
    return section;
  }

  // ---------- Cart drawer shipping badge ----------
  function injectCartShippingBadge() {
    var drawerInner = document.querySelector('cart-drawer .drawer__inner') || document.querySelector('cart-drawer .drawer__contents') || document.querySelector('cart-drawer .drawer');
    if (!drawerInner) return;
    if (drawerInner.querySelector('.rc-cart-shipping-badge')) return;
    var badge = document.createElement('div');
    badge.className = 'rc-cart-shipping-badge';
    badge.innerHTML = [
      '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>',
      '<span><strong>Free shipping across India</strong> on every order</span>'
    ].join('');
    var heading = drawerInner.querySelector('.drawer__heading, .drawer__header');
    if (heading && heading.parentNode === drawerInner) {
      heading.parentNode.insertBefore(badge, heading.nextSibling);
    } else {
      drawerInner.insertBefore(badge, drawerInner.firstChild);
    }
  }

  // ---------- Floating WhatsApp FAB ----------
  function setupFloatingWhatsApp() {
    if (document.querySelector('.rc-fab-whatsapp')) return;
    var msg = encodeURIComponent('Hi RoyalChicByPriti! I have a question.');
    var fab = document.createElement('a');
    fab.className = 'rc-fab-whatsapp';
    fab.href = 'https://wa.me/' + WHATSAPP_NUMBER + '?text=' + msg;
    fab.target = '_blank';
    fab.rel = 'noopener';
    fab.setAttribute('aria-label', 'Chat with us on WhatsApp');
    fab.innerHTML = [
      '<svg width="28" height="28" viewBox="0 0 24 24" fill="#fff">',
      '<path d="M17.5 14.4c-.3-.1-1.8-.9-2-1s-.5-.1-.7.1-.8 1-1 1.2-.4.2-.7.1-1.3-.5-2.5-1.5c-.9-.8-1.5-1.8-1.7-2.1-.2-.3 0-.5.1-.6s.3-.3.4-.5c.1-.2.2-.3.2-.5s-.1-.4-.2-.5c-.1-.1-.7-1.7-1-2.3-.3-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.7.4-.3.3-1 1-1 2.4s1 2.8 1.2 3 2 3 4.8 4.2c.7.3 1.2.5 1.6.6.7.2 1.3.2 1.8.1.5-.1 1.7-.7 2-1.4.2-.7.2-1.3.2-1.4-.1-.1-.3-.2-.5-.3z"/>',
      '<path d="M12 2C6.5 2 2 6.5 2 12c0 1.8.5 3.5 1.4 5L2 22l5.2-1.4c1.4.8 3 1.2 4.8 1.2 5.5 0 10-4.5 10-10S17.5 2 12 2zm0 18.2c-1.6 0-3.1-.4-4.4-1.2l-.3-.2-3.2.9.9-3.1-.2-.3c-.9-1.4-1.3-3-1.3-4.6 0-4.5 3.7-8.2 8.2-8.2s8.2 3.7 8.2 8.2-3.7 8.2-8.2 8.2z"/>',
      '</svg>'
    ].join('');
    document.body.appendChild(fab);
  }

  // ---------- Newsletter Popup ----------
  function getNewsletterStatus() {
    try { return JSON.parse(localStorage.getItem(NEWSLETTER_KEY) || 'null'); } catch (e) { return null; }
  }

  function setNewsletterStatus(status) {
    try {
      localStorage.setItem(NEWSLETTER_KEY, JSON.stringify({ status: status, ts: Date.now() }));
    } catch (e) {}
  }

  function shouldShowNewsletter() {
    var s = getNewsletterStatus();
    if (!s) return true;
    if (s.status === 'subscribed') return false;
    if (s.status === 'dismissed') {
      var daysSince = (Date.now() - (s.ts || 0)) / 86400000;
      return daysSince > NEWSLETTER_REPROMPT_DAYS;
    }
    return true;
  }

  function saveNewsletterEmail(email) {
    try {
      var list = JSON.parse(localStorage.getItem(NEWSLETTER_EMAILS_KEY) || '[]');
      list.push({ email: email, ts: Date.now() });
      localStorage.setItem(NEWSLETTER_EMAILS_KEY, JSON.stringify(list));
    } catch (e) {}
  }

  function showNewsletterPopup() {
    if (document.getElementById('rcNewsletterPopup')) return;
    var popup = document.createElement('div');
    popup.className = 'rc-newsletter-popup';
    popup.id = 'rcNewsletterPopup';
    popup.setAttribute('role', 'dialog');
    popup.setAttribute('aria-modal', 'true');
    popup.innerHTML = [
      '<div class="rc-newsletter-popup__overlay"></div>',
      '<div class="rc-newsletter-popup__card">',
      '  <button type="button" class="rc-newsletter-popup__close" aria-label="Close">&times;</button>',
      '  <div class="rc-newsletter-popup__form-state">',
      '    <span class="rc-newsletter-popup__badge">Limited offer</span>',
      '    <h3 class="rc-newsletter-popup__heading">Get 5% off your first order</h3>',
      '    <p class="rc-newsletter-popup__sub">Subscribe for exclusive offers and style inspiration from Chandni Chowk.</p>',
      '    <form class="rc-newsletter-popup__form">',
      '      <input type="email" required placeholder="your@email.com" aria-label="Email address">',
      '      <button type="submit">Get my code</button>',
      '    </form>',
      '    <p class="rc-newsletter-popup__legal">No spam. Unsubscribe anytime.</p>',
      '  </div>',
      '  <div class="rc-newsletter-popup__success-state" hidden>',
      '    <div class="rc-newsletter-popup__success-icon">✓</div>',
      '    <h3 class="rc-newsletter-popup__heading">Thank you!</h3>',
      '    <p class="rc-newsletter-popup__sub">Use this code at checkout for 5% off:</p>',
      '    <div class="rc-newsletter-popup__code">WELCOME5</div>',
      '    <button type="button" class="rc-newsletter-popup__dismiss">Continue shopping</button>',
      '  </div>',
      '</div>'
    ].join('');
    document.body.appendChild(popup);

    function close() {
      popup.classList.add('rc-newsletter-popup--closing');
      setTimeout(function () { if (popup.parentNode) popup.parentNode.removeChild(popup); }, 250);
      setNewsletterStatus('dismissed');
    }
    popup.querySelector('.rc-newsletter-popup__close').addEventListener('click', close);
    popup.querySelector('.rc-newsletter-popup__overlay').addEventListener('click', close);
    popup.querySelector('.rc-newsletter-popup__dismiss').addEventListener('click', close);

    popup.querySelector('.rc-newsletter-popup__form').addEventListener('submit', function (e) {
      e.preventDefault();
      var email = e.target.querySelector('input[type="email"]').value;
      saveNewsletterEmail(email);
      setNewsletterStatus('subscribed');
      popup.querySelector('.rc-newsletter-popup__form-state').setAttribute('hidden', '');
      popup.querySelector('.rc-newsletter-popup__success-state').removeAttribute('hidden');
    });

    // Trigger CSS open animation
    requestAnimationFrame(function () { popup.classList.add('rc-newsletter-popup--open'); });
  }

  function setupNewsletterPopup() {
    if (!shouldShowNewsletter()) return;
    setTimeout(showNewsletterPopup, NEWSLETTER_DELAY_MS);
  }

  // ---------- Mount logic ----------
  function mountProductEnhancements() {
    if (!isProductPage()) return;
    var product = readProductMeta();
    if (product.title && product.url) saveRecentlyViewed(product);
    var anchor = document.querySelector('product-form') || document.querySelector('.product-form') || document.querySelector('form[action*="/cart/add"]');
    if (anchor) {
      var trustBlock = buildPdpTrustBlock(product);
      anchor.parentNode.insertBefore(trustBlock, anchor.nextSibling);
      var waBtn = buildWhatsAppButton(product);
      anchor.parentNode.insertBefore(waBtn, trustBlock.nextSibling);
    }
    if (window.matchMedia('(max-width: 749px)').matches) {
      document.body.appendChild(buildStickyMobileBar(product));
      document.body.classList.add('has-rc-sticky-cart');
    }
    var rvSection = renderRecentlyViewed();
    if (rvSection) {
      var main = document.getElementById('MainContent') || document.querySelector('main');
      if (main) main.appendChild(rvSection);
    }
  }

  function init() {
    setupAnnouncementMarquee();
    mountProductEnhancements();
    injectCartShippingBadge();
    setupFloatingWhatsApp();
    /* newsletter 5% popup disabled per request (Priti) */
    document.addEventListener('cart:open', injectCartShippingBadge);
    document.addEventListener('cart-drawer:open', injectCartShippingBadge);
    document.addEventListener('cart:updated', injectCartShippingBadge);
    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      var obs = new MutationObserver(function () { injectCartShippingBadge(); });
      obs.observe(drawer, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
